import {createGAEvent} from '@optimaxdev/analytics/desktop/lib/gaEvent/index';
import {pushDataLayer} from '@optimaxdev/analytics/desktop/lib/pushDataLayer/index';
import md5 from 'blueimp-md5';

import {GENERAL_NEWSLETTER_INDICATION} from 'constants/analytics/events/general';

import {ENDPOINTS} from 'constants/endpoints';
import {apiConfig} from 'libs/api/api';

/**
 * Send event to dataLayer with place where we subscribe on newsletter
 * @param {string} email - user email
 * @param {string} place - subscribe place
 */
export const sendEventForPlaceSubscribe = async (email: string, place: string) => {
    try {
        if (!place || !email) return;

        const response = await apiConfig.instanceGusaBackend({
            baseURL: apiConfig.API_URL,
            data: {
                destination: email,
                type: 'email',
            },
            method: 'post',
            url: ENDPOINTS.NEWSLETTER_SUBSCRIPTION_INFO,
            validateStatus: requestStatus =>
                (requestStatus >= 200 && requestStatus < 300) || requestStatus === 404,
        });

        if (response?.data?.messages?.error[0]?.code === 400) throw new Error('Error');
    } catch (error) {
        pushDataLayer({
            ...createGAEvent(GENERAL_NEWSLETTER_INDICATION, {
                action: 'Newsletter Subscription',
                label: place,
                version: 'D',
            }),
            filled_email: md5(email.trim().toLowerCase()),
        });
    }
};
